/**
 * 036 T028 — the envelope's three header names, defined once (`contracts/replayable-writes.md`).
 *
 * A header name spelled at every call site is a name that can drift between them without either
 * side noticing — the server would simply not see the second spelling, silently, since CORS
 * strips an unlisted header rather than refusing it (research F-015). `outbox.store.ts` is the
 * only production module that sends these; this file exists so a contract test can assert the
 * exact literal each one names, independent of that module's own logic.
 *
 * `CURRENT_WIRE_VERSION` lives here rather than in `outbox.store.ts` for the same reason: it is
 * read when an item is WRITTEN (data-model.md's `wireVersion` — "the format this item was written
 * in, not the build's current one") and again when one is READ back to decide whether this build
 * can make sense of it. Two readers of one constant, not two constants that happen to agree.
 */
export const IDEMPOTENCY_KEY_HEADER = 'Idempotency-Key';
export const WIRE_VERSION_HEADER = 'X-Wire-Version';
export const MADE_AT_HEADER = 'X-Made-At';

/** `contracts/replayable-writes.md`: "`1` in this cycle." */
export const CURRENT_WIRE_VERSION = 1;
